window.onload = function() {
    const sliderExist = document.querySelectorAll("#slider_brands").length;

    if(sliderExist != 0) {
    document.addEventListener("scroll", sliderStart, false);
        sliderStart();
    }

    const formColorSwatch = document.querySelectorAll("form[data-url] label.color-swatch");
    formColorSwatch.forEach(element => {
        element.addEventListener("click", () => {
            const url = "https://onne.com" + element.parentElement.closest('form').dataset.url + ".js";
            const idVariant = element.dataset.variant;
            getProduct(url, changePrice, idVariant);
        }, false)
    });
    
}

function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    );
}

function sliderStart() {
    const slider = document.getElementById("slider_brands");
    if (isInViewport(slider)) {
        const root = document.querySelector(':root');
        sliderWidth( slider, '--sliderBrandsWidth', root);
        root.style.setProperty( "--animationName", "animateBrands");

        var clone = slider.cloneNode(true);
        clone.setAttribute("id", "");
        slider.parentElement.appendChild(clone);

        document.removeEventListener("scroll", sliderStart, false);
        window.addEventListener('resize', function() { sliderWidth( slider, '--sliderBrandsWidth', root);}, false);
    }
 }

function sliderWidth($element, $var, $root) {
    var sliderWidth = "-" + $element.offsetWidth + "px";
    $root.style.setProperty($var,  sliderWidth);
}

//getProduct(window.Shopify.routes.root + '/products/' + 'products/palmyra-top-rib.js')


//Funcion para obtener datos de un producto especifico
const getProduct = ($url, $callback, $params) => {
    const params = $params;
    fetch($url,{ 
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      return response.json();
    })
    .then(data => {
      $callback(data, params)
    });
  };

const changePrice = (data, params) => {
    const variant = data.variants.filter( (v) => { return v.id == params } );

    const price = fixedPrice(variant[0].price);
    const compareAtPrice = fixedPrice(variant[0].compare_at_price);

    const productId = "#product_form_" + variant[0].featured_image.product_id;

    const precio_compare = document.querySelector(productId + " .grid-product__price--original span");
    const precio = document.querySelector(productId + " .precio-oferta span");

    precio_compare.innerText = compareAtPrice;
    precio.innerText = price;

}

function fixedPrice(price) {
    return "€" + (((parseInt(price) / 100).toFixed(2)).toString()).replace(".", ",");;
}